import React, { useState, useEffect } from 'react';

import UseStyles from '../../useStyles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";

import TrashIcons from "../../../../images/icons/trash-can-delete-icon.svg";

const DocumentosReuniao = (props) => {

  const [nomeArquivo, setNomeArquivo] = useState();
  const [tipoArquivo, setTipoArquivo] = useState(1);

  const tiposArquivos = [
    'Outros', 'Encaminhamento de assunto',
    'Parecer Jurídico', 'Apresentação', 'Relatório – Súmula do CDE'
  ].map((item, key) => (
    <MenuItem selected={key === tipoArquivo - 1} key={key} value={key + 1}>{item}</MenuItem>
  ));

  const classes = UseStyles();

  const {
    file,
    uploadTime,
    onDelete,
    onChangeHandle,
    key
  } = props;

  const separarNome = (nome) => nome.split('.')[0];
  const separarTipo = (tipo) => tipo.split('.')[1];
  const getSize = (numero) => {
    if (numero >= (1024 * 1024 * 1024)) {
      return `${parseInt(numero / (1024 * 1024 * 1024))}gb`;
    }
    if (numero >= (1024 * 1024)) {
      return `${parseInt(numero / (1024 * 1024))}mb`;
    }
    if (numero >= 1024) {
      return `${parseInt(numero / 1024)}kb`;
    }
    return `${numero}bytes`;
  }

  const getLastUploadDate = (data) => {
    const dataHoje = new Date().getTime();
    const dataUpload = data ? new Date(data).getTime() : dataHoje;
    const dias = dataHoje - dataUpload;
    return dias >= 1000 * 3600 * 24 ? parseInt((dataHoje - dataUpload) / (1000 * 3600 * 24)) : 0;
  };

  const getDia = (data) => {
    const dia = getLastUploadDate(data);
    if (dia === 0 || dia === 1) {
      return ` ${dia} dia`
    } else {
      return `${dia} dias`
    }
  }

  useEffect(() => {
    // TODO Melhorar edição de documentos
    setNomeArquivo(file.nome);
    //setTipoArquivo(file.tipo);
    //setTipoArquivo(file.tipo);
    if (file.id) {
      [
        'Outros', 'Encaminhamento de assunto',
        'Parecer Jurídico', 'Apresentação', 'Relatório – Súmula do CDE'
      ].map((item, key) => {
        if (item === file.arquivo.tipo) {
          setTipoArquivo(key + 1);
        }
      });
    }
  }, [])

  useEffect(() => {
    file.nome = nomeArquivo + "";
  }, [nomeArquivo]);

  useEffect(() => {
    file.tipo = Number(tipoArquivo);
  },[tipoArquivo]);

  return (
    <>
      <Grid key={separarNome(file.arquivo.name) + key + '1'} item md={3} sm={6} xs={6}>
        <Typography className={classes.gridNomeArquivo}>{separarNome(file.arquivo.name)}</Typography>
        <Typography className={classes.gridNomeArquivoDetalhe}>Adicionado há {getDia(file.dataUltimoAcesso)} - {separarTipo(file.arquivo.name)}</Typography>
      </Grid>
      <Grid key={separarNome(file.arquivo.name) + key + '2'} item md={3} sm={6} xs={6} style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          value={nomeArquivo}
          variant="outlined"
          disabled={file.id}
          autoFocus
          onChange={(e) => setNomeArquivo(e.target.value)}
          fullWidth
          InputProps={{
            disableUnderline: 'true',
          }}
          InputLabelProps={{ shrink: 'true' }}
        />
      </Grid>
      <Grid key={separarNome(file.arquivo.name) + key + '3'} item md={3} sm={6} xs={6} style={{ display: 'flex', alignItems: 'center' }}>
        <Select
          value={tipoArquivo}
          variant="outlined"
          disabled={file.id}
          onChange={(e) => setTipoArquivo(e.target.value)}
          disableUnderline
          InputProps={{ disableUnderline: 'true' }}
          InputLabelProps={{ shrink: 'true' }}
          IconComponent={ExpandMoreIcon}
          placeholder={tipoArquivo}
          fullWidth >
          {tiposArquivos}
        </Select>
      </Grid>
      <Grid key={separarNome(file.arquivo.name) + key + '4'} style={{ display: 'flex', alignItems: 'center' }} item md={2} sm={4} xs={4}>
        <Typography className={classes.gridTamanho}>{getSize(file.arquivo.size)}</Typography>
      </Grid>
      <Grid key={separarNome(file.arquivo.name) + key + '5'} style={{ display: 'flex', justifyContent: 'center' }} item md={1} sm={2} xs={2}>
        <img onClick={onDelete} style={{ margin: 'auto', cursor: 'pointer' }} src={TrashIcons} />
      </Grid>
    </>
  );
}

export default DocumentosReuniao;
